import type {
  UpdateUserMutation,
  UpdateUserMutationVariables
} from './__generated__/UpdateUserMutation'
import { ApolloClient, gql, TypedDocumentNode } from '@apollo/client'
import { userFragment } from '../fragments/UserFragment'

const mutation: TypedDocumentNode<
  UpdateUserMutation,
  UpdateUserMutationVariables
> = gql`
  ${userFragment}

  mutation UpdateUserMutation($input: UpdateUserInput!, $locale: String) {
    updateUser(input: $input) {
      user {
        ...UserFragment
      }
    }
  }
`

export function updateUserMutation(
  apolloClient: ApolloClient,
  options: Omit<
    ApolloClient.MutateOptions<UpdateUserMutation, UpdateUserMutationVariables>,
    'mutation'
  >
) {
  return apolloClient.mutate({
    mutation,
    ...options
  })
}
